module.exports = __webpack_public_path__ + "img/img_back_brown.d730b2c6.png";